// Ahlam reveal-on-scroll — adds .is-visible when sections enter the viewport.
// Skips if user prefers reduced motion.
(function () {
  if (typeof window === 'undefined') return;
  const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (mq.matches) return;

  const init = () => {
    const targets = document.querySelectorAll(
      '.shopify-section:not([class*="header"]):not([class*="footer"]):not([class*="announcement"])'
    );
    if (!targets.length || typeof IntersectionObserver === 'undefined') return;

    targets.forEach((el) => el.classList.add('ahlam-reveal'));

    const io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }
    );

    // Make first viewport sections visible immediately (avoid initial blank)
    targets.forEach((el, i) => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.95) {
        el.classList.add('is-visible');
      } else {
        io.observe(el);
      }
    });
  };

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  }
})();
